module.exports = __webpack_public_path__ + "img/success.e0aa90fe.png";